export default "__VITE_ASSET__oKnPjZQc__"